module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popular",
    attrs: {
      "id": "popular"
    }
  }, [_c('section', {
    staticClass: "man-top"
  }, [_vm._m(0), _vm._v(" "), (_vm.screenWidth > 1200) ? _c('img', {
    attrs: {
      "src": require("../assets/images/d-popular-title.png"),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/m-popular-title.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vote-pd-class-container"
  }, _vm._l((_vm.allProcuctClass), function(ProcuctClass, index) {
    return _c('div', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#category-conatiner' + index + ''),
        expression: "'#category-conatiner'+index+''"
      }],
      key: ProcuctClass.engName,
      staticClass: "vote-pd-class-text"
    }, [_c('p', {
      staticClass: "vote-pd-class-eng"
    }, [_vm._v(_vm._s(ProcuctClass.engName))]), _vm._v(" "), _c('h3', {
      staticClass: "vote-pd-class-chi"
    }, [_vm._v(_vm._s(ProcuctClass.chiName))])])
  }))]), _vm._v(" "), _c('section', {
    staticClass: "man-pd-container"
  }, _vm._l((_vm.manProduct), function(category, index) {
    return _c('div', {
      staticClass: "category-conatiner",
      attrs: {
        "id": 'category-conatiner' + index
      }
    }, [_c('div', {
      staticClass: "category-title"
    }, [_c('p', {
      staticClass: "category-name-eng"
    }, [_vm._v(_vm._s(_vm.allProcuctClass[index].engName) + " ")]), _vm._v(" "), _c('h1', {
      staticClass: "category-name"
    }, [_vm._v(_vm._s(_vm.allProcuctClass[index].chiName) + " ")])]), _vm._v(" "), _c('div', {
      key: category[1].no,
      staticClass: "pd-item pd-top1",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[1].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[1])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[1].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[1].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      key: category[2].no,
      staticClass: "pd-item pd-top2",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[2].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[2])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[2].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[2].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      key: category[3].no,
      staticClass: "pd-item pd-top3",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[3].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[3])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[3].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[3].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      key: category[4].no,
      staticClass: "pd-item pd-star",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(category[4].image) + ')'
      }),
      attrs: {
        "data-toggle": "modal",
        "data-target": "#Modal"
      },
      on: {
        "click": function($event) {
          _vm.saveModalShowPd(category[4])
        }
      }
    }, [_c('div', {
      staticClass: "pd-cover"
    }, [_c('h4', {
      staticClass: "pd-brand"
    }, [_vm._v(" " + _vm._s(category[4].brand) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(category[4].product) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "pd-detail"
    }, [_vm._v("\n\t\t\t\t\t\t產品說明\n\t\t\t\t\t")])])])])
  })), _vm._v(" "), _c('section', {
    staticClass: "event-description"
  }, [_c('ul', {
    staticClass: "event-list"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_vm._v("活動贈品\n\t\t\t\t"), (_vm.screenWidth > 1200) ? _c('img', {
    staticClass: "gift",
    attrs: {
      "src": require("../assets/images/d-gift.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "gift-m",
    attrs: {
      "src": require("../assets/images/m-gift.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "modalShownSon": _vm.modalShown,
      "votePageShowPd": _vm.modalPd,
      "imgUrl": _vm.cosmoUrl,
      "sendPage": 'man'
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "bw-logo",
    attrs: {
      "href": "http://www.cosmopolitan.com.tw/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/bw-logo.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("評選說明\n\t\t\t\t"), _c('p', [_vm._v("於活動期間 2017/09/11 ~ 09/24，從專業美容老師所評選出 16 個品項的 TOP 10，選擇你喜愛的產品進行投票，與我們共同評選出人氣口碑獎，有機會獲得柯夢波丹為你準備的精美美妝小禮!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("得獎權利與義務\n\t\t\t\t"), _c('p', [_vm._v("依照中華民國國稅局規定，參加任何活動得獎，獎項價值超過新台幣10,000以上須做得獎申報扣繳，得獎者應先傳真(02-2500-1986)或郵寄提供申報相關文件(身分證正反影本)予主辦單位，始得領取活動獎品。活動獎項價值超過新台幣20,000元者，得獎者應自行負擔10%之機會中獎所得稅。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("注意事項\n\t\t\t\t"), _c('ul', {
    staticClass: "care-list"
  }, [_c('li', [_vm._v("每人限得獎一次，若發現重複得獎，主辦單位得取消其中任一獎項，並由備取者遞補。")]), _vm._v(" "), _c('li', [_vm._v("本活動限中華民國台灣地區(台澎金馬地區)之使用者參加，本活動之獎品不得轉換、轉讓或折換現金。")]), _vm._v(" "), _c('li', [_vm._v("活動期間如有任何問題，可來信至e-mail:cosmo_service@hearst.com.tw 聯絡。")]), _vm._v(" "), _c('li', [_vm._v("參加者於參加活動同時，即同意接受本活動注意事項之規範，如果違反本活動注意事項之行為，主辦單位得取消其參加或得獎資格，並對於任何破壞活動之行為保留相關權利。")]), _vm._v(" "), _c('li', [_vm._v("請確認註冊Facebook皆為正確資料，主辦方所有資料皆會保密，只作為參賽者聯繫、聯絡通知或獎品寄送之依據。填寫錯誤資訊以致 聯絡誤差，將視同放棄參賽資格。")]), _vm._v(" "), _c('li', [_vm._v("參加者所參與獲提供的活動內容，不符合活動辦法之規範，主辦單位得取消其參加或得獎資格，且不另行通知。")]), _vm._v(" "), _c('li', [_vm._v("如果不實或不正確之情事，將被取消參加資格:如為得獎者，則取消得獎資格。如因此致主辦單位無法通知其得獎訊息時，主辦單位不負任何責任。且如有致損害於主辦單位或其他任何第三人，參加者應負一切民刑事責任。")]), _vm._v(" "), _c('li', [_vm._v("如有任何因電腦、網路、電話、技術或不可歸責於主辦單位之事由，而使寄予得獎人之獎品有延遲、遺失、錯誤、無法辨識或毀損之 情況，主辦單位不負任何法律責任，參加者亦不得因此異議。")]), _vm._v(" "), _c('li', [_vm._v("活動因故無法進行時，主辦單位有權決定取消、終止、修改或暫停活動。")]), _vm._v(" "), _c('li', [_vm._v("活動獎項若因不可抗力因素需要調整，主辦單位保留改以他項等值獎品代替之權利。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("得獎名單\n\t\t\t\t"), _c('p', [_vm._v("公佈於 2017 10月 柯夢波丹粉絲團。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("領獎方式\n\t\t\t\t"), _c('ul', {
    staticClass: "care-list"
  }, [_c('li', [_vm._v("得獎者應於柯夢波丹通知之一週內回覆確認同意領取獎品，並提供柯夢波丹所要求之完整領獎文件，逾期視為棄權。")]), _vm._v(" "), _c('li', [_vm._v("台灣本島與澎湖、金馬地區:獎品將一律以掛號方式配送以避免遺失，得獎者須於名單公佈通知後，須回覆相關配送資料，逾期回覆則視同放棄領獎資格。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2fe1274","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popular.vue
// module id = 154
// module chunks = 0